import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }
const _hoisted_3 = ["value", "placeholder"]

import { Search } from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchBar',
  props: {
    modelValue: {},
    placeholder: {},
    hasError: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Search), { class: "h-5 w-5 text-gray-400 dark:text-gray-500 z-10" })
    ]),
    _createElementVNode("input", {
      value: __props.modelValue,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', ($event.target as HTMLInputElement).value))),
      type: "text",
      placeholder: __props.placeholder,
      class: _normalizeClass(["input pl-10", { 'input-error': __props.hasError }])
    }, null, 42, _hoisted_3)
  ]))
}
}

})